import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { BF2GetConfigBasedOutskirtBuilding } from "./BF2GetConfigBasedOutskirtBuilding";
export var BF2GetOutskirtBuildingThemedEvent = function (data, level, buildingState, isAccessible, buildingName) {
    var config = artConfigBuildings["ThemedEvent" + buildingName];
    return BF2GetConfigBasedOutskirtBuilding(config, false, 1.2);
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetOutSkirtBuildingThemedEvent.ts
// module id = 2169
// module chunks = 3